import React from 'react'
import { useRecoilValue } from 'recoil'
import { Box, DataTable, Text } from '@/presentation/components'
import { serviceOrderDetailState } from '@/presentation/pages/ServiceOrderDetail/components'
import { useFormat } from '@/presentation/hooks'
import { styles } from '../../styles'

export const OsRemovals: React.FC = () => {
  const serviceOrderDetail = useRecoilValue(serviceOrderDetailState)
  const { formatCurrency } = useFormat()

  const totalBrutoProdutos = serviceOrderDetail.listaProdutosRetirar?.reduce(
    (acc, produto) => acc + produto.total,
    0
  )

  return (
    <>
      {!!serviceOrderDetail.listaProdutosRetirar?.length &&
        <>
          <Text style={styles.pageInfo}>Produtos a Retirar do Cliente</Text>
          <DataTable>
            <DataTable.Header>
              <DataTable.Title>Descrição</DataTable.Title>
              <DataTable.Title>Quantidade</DataTable.Title>
              <DataTable.Title>Unitário</DataTable.Title>
              <DataTable.Title>Total</DataTable.Title>
              <DataTable.Title>Cobrança</DataTable.Title>
              <DataTable.Title>Motivo</DataTable.Title>
            </DataTable.Header>

            {serviceOrderDetail.listaProdutosRetirar.map((retirar, index) => (
              <DataTable.Row key={index}>
                  <DataTable.Cell>{retirar.descricao}</DataTable.Cell>
                  <DataTable.Cell>{retirar.quantidade}</DataTable.Cell>
                  <DataTable.Cell>{retirar.unitario}</DataTable.Cell>
                  <DataTable.Cell>{retirar.total}</DataTable.Cell>
                  <DataTable.Cell>{retirar.cobraCliente ? 'SIM' : 'NÃO'}</DataTable.Cell>
                  <DataTable.Cell>{retirar.motivo}</DataTable.Cell>
              </DataTable.Row>
            ))}
          </DataTable>
          <Box style={styles.totalizerTextBox}>
              <Text><span style={styles.bold}>Total de Produtos a Retirar: </span>{formatCurrency(totalBrutoProdutos)}</Text>
          </Box>
        </>
      }
    </>
  )
}
